import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import moment from "moment-timezone";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";

export default class FEAvailability extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_FIELD_ENGINEERS_HOLES';
		this.state.limit = 15;
		this.state.regions = [];
		this.state.selectedRegions = [];
		this.state.selectedUsers = [];
		this.state.filterDate = moment();
		this.state.days = this.formatDays();
		this.state.users = [];
		this.state.selectedDay = moment().tz("America/Phoenix").format();
		this.handleRegions = this.handleRegions.bind(this);
		this.formatDays = this.formatDays.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleUsers = this.handleUsers.bind(this);
	}

	async componentDidMount() {
		await this.getFEAvailability();
		await this.getRegions();
		await this.getUsers();
		if (!this.dataInterval && !this.props.forPhoneLog) {
			this.dataInterval = setInterval(async () => {
				await this.getFEAvailability();
			}, 30000)
		}
	}

	componentWillUnmount() {
		if (this.dataInterval) {
			clearInterval(this.dataInterval);
			this.dataInterval = null;
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.selectedRegion !== this.props.selectedRegion) {
			this.handleRegions(this.state.regions.filter((region) => region.pkey === this.props.selectedRegion).map((region) => {return {value: region.pkey, label: region.name}}))
		}
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
		return this.state.regions;
	}

	getUsers = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_CALENDAR_RESOURCES';
		model.limit = 5000;
		let usersPkeys = this.state.selectedUsers.map((user) => user.value)
		try {
			model.filter = {
				'filterRegions': this.state.selectedRegions.map((region) => region.value),
			}
			this.users = await model.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			let selected = this.users.filter(item => usersPkeys.includes(item.resourceId));
			if (selected.length !== 0) {
				this.state.selectedUsers = this.users.filter(item => usersPkeys.includes(item.resourceId)).map((user) => {
					return {value: user.resourceId, label: user.resourceTitle}
				});
			}
			this.setState({
				users: this.users,
				key: Math.random()
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	getFEAvailability = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		this.read = this.props.forPhoneLog ? 'GET_SCHEDULE_FIELD_ENGINEER' : 'GET_FIELD_ENGINEERS_HOLES';
		model.limit = 70;
		let week = moment(this.state.filterDate).isoWeek();
		if (moment(this.state.selectedDay).isoWeekday() === 7) {
			week++;
		}
		try {
			model.filter = {
				'filterDate': moment(this.state.selectedDay).format(),
				'filterRegions': this.state.selectedRegions.map((region) => region.value),
				'filterUsers': this.state.selectedUsers.map((user) => user.value),
				'timeOffWeek': moment(this.state.selectedDay).year().toString() + week.toString(),
				'trim': !this.props.showTotal,
				'forPhoneLog': this.props.forPhoneLog,
				'addOneDay': this.props.shouldAddDay
			}

			if (this.props.forPhoneLog) {
				model.filter = {...model.filter, 'filterBool': true}
			}
			//model.search = this.state.search
			this.feAvailability = await model.submit(null, this.read);
			if (this.props.forPhoneLog) {
				let filterDate = this.feAvailability.newFilterDate ?? null;
				this.feAvailability = this.feAvailability.items
				if (filterDate) {
					this.setState({selectedDay: filterDate})
					if (typeof(this.props.shouldShowWarning) === 'function') {
						this.props.shouldShowWarning(filterDate);
					}
				}
			} else {
				this.feAvailability = Object.keys(this.feAvailability).map((key) => this.feAvailability[key]);
				this.feAvailability = this.feAvailability[3];
			}
			if (this.state.selectedUsers.length === 0 && this.state.selectedRegions.length === 0 && this.props.showTotal) {
				let totalHoles = 0;
				this.feAvailability.map((item) => {
					totalHoles += parseInt(item.holes);
				})
				 this.feAvailability.unshift({
					resourceTitle: "",
					holes: `TOTAL HOLES FOR SELECTED DAY = ${totalHoles}`,
					availability: ""
				})
			}
			this.setState({
				data: this.feAvailability,
			});

			if (typeof(this.props.toggleShowSecondDay) === 'function' && this.feAvailability.length < 7 && this.state.selectedRegions.length === 0) {
				this.props.toggleShowSecondDay();
			}

		} catch (error) {
			console.log('ERROR', error)
		}
	}

	formatDays = () => {
		let days = [{value: moment().tz("America/Phoenix").format(), label: "Today"},]
		for (let i = 1; i <= 365; i++) {
			days.push({
				value: moment().tz("America/Phoenix").add(i, 'day').format().toString(),
				label: moment().tz("America/Phoenix").add(i, 'day').format("dddd, MMMM Do").toString()
			})
		}
		return days;
	}

	handleSelect = (day) => {
		if (typeof(this.props.updateDate) === 'function') {
			this.props.updateDate(moment(day.value).format('YYYY-MM-DD'))
		}
		this.state.selectedDay = day.value
		this.getFEAvailability().then();
	}

	handleRegions(value) {
		if (value) {
			let regions = [];
			for (let i = 0; i < value.length; i++) {
				regions.splice(0, 0, value[i]);
			}
			this.state.selectedRegions = regions;
		} else {
			this.state.selectedRegions = [];
		}
		this.getFEAvailability().then();
		this.getUsers().then();
	}

	handleUsers(value) {
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i]);
			}
			this.state.selectedUsers = users;
		} else {
			this.state.selectedUsers = [];
		}
		this.getFEAvailability().then();
		this.getUsers().then();
	}

	refreshPage = () => {
		this.getFEAvailability().then();
		this.getUsers().then();
	};


	render() {
		const {data, pages, limit, loading, days} = this.state;
		//console.log(this.props.shouldAddDay, data)
		const holesColumn = this.props.showTotal ? {
			Header: "Available Holes",
			id: 'holes',
			accessor: obj => obj.headerOverride ? '' : obj.holes
		} : {
			Header: "Holes",
			id: 'holes',
			accessor: obj => obj.headerOverride ? '' : obj.holes,
			width: 80
		}
		const columns = [

			{
				Header: "Field Engineer",
				id: 'resourceTitle',
				/** @param {Users_Object} obj */
				accessor: obj => obj.headerOverride ? obj.headerOverride : obj.resourceTitle,
			},
			holesColumn,
			{
				Header: "Available Timeslots",
				id: 'availability',
				accessor: obj => obj.headerOverride ? '' : obj.availability,
				Cell: (obj) => {
					if (obj.original.availability === "") {
						return (<p>{obj.original.availability}</p>)
					} else if (obj.headerOverride){
						return null;
					}
					else {
						let day = this.state.selectedDay === undefined ? moment().format('YYYY-MM-DD').toString() : this.state.selectedDay;
						return (
							<span>
								<Link to={`/dispatch/calendar/toDate/${day}`}>
									{obj.original.availability}
								</Link>
							</span>
						)

					}
				}
			},
		]

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="row">
							<div className={'col'}>
								<Select
									key={this.state.regions}
									placeholder={"Region Select"}
									isMulti
									isClearable
									value={this.state.selectedRegions.map(region => {
										return (
											{value: region.value, label: region.label})
									})}
									onChange={this.handleRegions}
									options={this.state.regions.map(region => {
										return (
											{value: region.pkey, label: region.name})
									})}
								/>
							</div>
							<div className={this.props.forPhoneLog ? 'col' : "col-2"}>
								{this.state.days.length !== 0 && <Select
									name={"Date"}
									options={days}
									onChange={this.handleSelect}
									maxMenuHeight={150}
									value={this.state.selectedDay ? days.filter((day) => day.value.split("T")[0] === this.state.selectedDay.split('T')[0])[0] : days[0]}
								/>}
							</div>
							{!this.props.forPhoneLog && <div className={"col"}>
								<Select
									key={this.state.users}
									placeholder={"User Select"}
									isMulti
									isClearable
									value={this.state.selectedUsers.map(user => {
										return (
											{value: user.value, label: user.label})
									})}
									onChange={this.handleUsers}
									options={this.state.users.map(user => {
										return (
											{value: user.resourceId, label: user.resourceTitle})
									})}
								/>
							</div>}
							{!this.props.forPhoneLog && <div className={'col-1 d-flex justify-content-end align-items-center'}>
								<Button onClick={async () => {
									await this.refreshPage();
								}} size={"sm"} color="primary">
									<i className="fa fa-users"/>Refresh Data
								</Button>
							</div>}
						</div>
					</div>
					<ReactTable
						key={this.state.data}
						columns={columns}
						manual={!!!this.props.forPhoneLog}
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.props.forPhoneLog ? () => {} : this.getFEAvailability} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={this.props.forPhoneLog ? this.state.data.length > 15 ? 15 : this.state.data.length : limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={this.props.forPhoneLog ? this.state.data.length > 15 ? 15 : this.state.data.length : limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
